import { IFile } from '@sdk/contracts';
import { Button, Checkbox } from 'antd';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EditTextWrapper, TextWrapper, Wrapper } from './MaterialElement.styles';

import { Icon } from '@/components/Icon';
import { useLocalCourse, useMoveOrRemoveMaterial, useMutateCourses, useProfile } from '@/store';

type Props = {
  file: IFile;
};

export const MaterialElement: FC<Props> = ({ file }) => {
  const { t } = useTranslation('CourseTranslations');
  const {
    roleCheck: { isManager }
  } = useProfile();
  const [editing, setEditing] = useState(false);
  const { data, setData } = useMoveOrRemoveMaterial();
  const { course } = useLocalCourse();
  const { updateMaterialName } = useMutateCourses();
  const isChecked = useMemo(() => Boolean(data?.find(m => m._id === file._id)), [data]);

  const handleUpdateMaterialName = (newMaterialName: string) => {
    if (!course) return;
    if (newMaterialName !== file.name) {
      updateMaterialName({
        courseId: course._id,
        fileId: file._id,
        newName: newMaterialName
      });
    }
  };

  const handleCheckBox = () => {
    if (isChecked) {
      setData(data?.filter(m => m._id !== file._id));
      return;
    }

    setData([...(data || []), file]);
  };

  return (
    <Wrapper>
      {isManager && <Icon i="OverflowMenuVertical" />}
      <Checkbox checked={isChecked} onClick={handleCheckBox} />
      <Icon i="Document" />
      <TextWrapper
        onClick={() => !editing && window.open(file.url, '_blank')}
        editable={
          isManager && {
            editing,
            onChange: handleUpdateMaterialName,
            onCancel: () => setEditing(false),
            onEnd: () => setEditing(false),
            icon: <></>
          }
        }>
        {file.name}
      </TextWrapper>
      {isManager && !editing && (
        <div>
          <Button
            size="small"
            type="link"
            icon={<Icon i="Edit" />}
            onClick={() => setEditing(true)}></Button>
          <EditTextWrapper>{t('EDIT_NAME')}</EditTextWrapper>
        </div>
      )}
    </Wrapper>
  );
};
